/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeNotificationActionResponse,
  ApiEnvelopeNotificationListResponse
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type notificationListResponse200 = {
  data: ApiEnvelopeNotificationListResponse
  status: 200
}

export type notificationListResponseSuccess = (notificationListResponse200) & {
  headers: Headers;
};
;

export type notificationListResponse = (notificationListResponseSuccess)

export const getNotificationListUrl = () => {




  return `/api/notifications`
}

export const useNotificationListHook = (): ( options?: RequestInit) => Promise<notificationListResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getNotificationListUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type notificationReadAllResponse200 = {
  data: ApiEnvelopeNotificationActionResponse
  status: 200
}

export type notificationReadAllResponseSuccess = (notificationReadAllResponse200) & {
  headers: Headers;
};
;

export type notificationReadAllResponse = (notificationReadAllResponseSuccess)

export const getNotificationReadAllUrl = () => {




  return `/api/notifications/read-all`
}

export const useNotificationReadAllHook = (): ( options?: RequestInit) => Promise<notificationReadAllResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getNotificationReadAllUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type notificationDismissResponse200 = {
  data: ApiEnvelopeNotificationActionResponse
  status: 200
}

export type notificationDismissResponseSuccess = (notificationDismissResponse200) & {
  headers: Headers;
};
;

export type notificationDismissResponse = (notificationDismissResponseSuccess)

export const getNotificationDismissUrl = (id: string,) => {




  return `/api/notifications/${id}/dismiss`
}

export const useNotificationDismissHook = (): (id: string, options?: RequestInit) => Promise<notificationDismissResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getNotificationDismissUrl(id),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type notificationDismissAllResponse200 = {
  data: ApiEnvelopeNotificationActionResponse
  status: 200
}

export type notificationDismissAllResponseSuccess = (notificationDismissAllResponse200) & {
  headers: Headers;
};
;

export type notificationDismissAllResponse = (notificationDismissAllResponseSuccess)

export const getNotificationDismissAllUrl = () => {




  return `/api/notifications/dismiss-all`
}

export const useNotificationDismissAllHook = (): ( options?: RequestInit) => Promise<notificationDismissAllResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getNotificationDismissAllUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


